import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  LinearProgress,
  Typography,
  Card,
  Stack,
  useMediaQuery,
  useTheme,
  Fab,
  Divider
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { BIBlue } from "../../assets/helpers";
import {
  FETCH_TICKETS,
  FETCH_USER_COMPANIES,
  FETCH_USER_EMAILS,
  FETCH_USER_PHONES,
  FETCH_USER_PRODUCTS,
  FETCH_USER_TRADE_CERTIFICATION,
  FETCH_USER_TRADES,
  FETCH_USERS_WORK_HISTORY,
  GENERATE_RESUME
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import moment from "moment";
import YourInfoCard from "./sections/YourInfoCard";
import TradesCard from "./sections/TradesCard";
import ExperienceCard from "./sections/ExperienceCard";
import EducationCard from "./sections/EducationCard";
import TicketCard from "./sections/TicketCard";
import ProductsCard from "./sections/ProductsCard";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import Pageheader from "../common/Pageheader";
import ResumeDetailsModal from "./ResumeDetailsModal";
import { English } from "../../constant/EnglishFallback";

const AddResume = ({
  fromJob,
  onClose,
  handleClose,
  fetchResumes,
  setOpenResumeBuilder,
  loadApi,
  setErrorMessage
}) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = Number(loginData?.userInformation?.UserId);
  const accessToken = loginData?.accessToken;
  const totalSteps = 3;
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [workHistorySites, setWorkHistorySites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [workHistory, setWorkHistory] = useState([]);
  const [unknownCompany, setUnknownCompany] = useState([]);
  const [userTrades, setUserTrades] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [products, setProducts] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [emails, setEmails] = useState([]);
  const [phones, setPhones] = useState([]);
  const [genResumeLink, setGenResumeLink] = useState("");
  const [openResumeBuilderModal, setOpenResumeBuilderModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_RESUME_INFO_HEADER = English.ResumeBuilder.TEXT_RESUME_INFO_HEADER,
    TEXT_RESUME_BUILDER_HEADER = English.ResumeBuilder.TEXT_RESUME_BUILDER_HEADER,
    TEXT_RESUME_INFO_SUBTITLE = English.ResumeBuilder.TEXT_RESUME_INFO_SUBTITLE,
    TEXT_GENERATE_RESUME_BTN = English.ResumeBuilder.TEXT_GENERATE_RESUME_BTN,
    TEXT_NEXT_PAGE_BTN = English.ResumeBuilder.TEXT_NEXT_PAGE_BTN,
    BUTTON_BACK = English.ResumeBuilder.BUTTON_BACK
  } = LanguageData || {};

  const headerName =
    location.pathname === "/resume-builder/add-resume" || fromJob === "apply-job"
      ? TEXT_RESUME_INFO_HEADER
      : TEXT_RESUME_BUILDER_HEADER;

  const getExperienceDetails = async () => {
    try {
      const fetchRequest = async (url, body) => {
        return Postrequestcall(url, body, accessToken);
      };
      const workHistoryObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 0,
        SearchList: [{ Id: 0, CreatedBy: userId }]
      };
      const userCompanyObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 0,
        SearchList: [{ UserId: userId }]
      };

      const [workHistoryResponse, userCompaniesResponse] = await Promise.all([
        fetchRequest(FETCH_USERS_WORK_HISTORY, workHistoryObj),
        fetchRequest(FETCH_USER_COMPANIES, userCompanyObj)
      ]);

      const workHistory = workHistoryResponse?.data?.data || [];
      const userCompanies = userCompaniesResponse?.data?.data || [];

      const companyMapping = userCompanies.reduce((map, company) => {
        map[company.companyId] = {
          ...company,
          experience: [],
          isSelected: true
        };
        return map;
      }, {});

      const noCompSites = [];
      workHistory.forEach((entry) => {
        if (entry.companyId === 0) {
          noCompSites.push(entry);
        } else if (companyMapping[entry.companyId]) {
          companyMapping[entry.companyId].experience.push({
            ...entry,
            isSelected: true
          });
        }
      });

      const noSiteExpData = noCompSites.map((entry) => ({
        ...entry,
        experience: [entry],
        isSelected: true
      }));

      const totalExpData = [...Object.values(companyMapping), ...noSiteExpData];

      const sortedExpData = totalExpData
        .filter((entry) => entry.startDate && entry.companyName)
        .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

      const noDateExp = totalExpData.filter(
        (entry) => !entry.startDate && !entry.endDate && entry.companyId !== 0 && entry.companyName
      );

      const unknownExpData = totalExpData
        .filter((entry) => !entry.companyName)
        .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

      const finalExpData = [...sortedExpData, ...noDateExp];

      setWorkHistory(finalExpData);
      setUnknownCompany(unknownExpData);
    } catch (err) {
      console.error("getExperienceDetails-> Error fetching experience details: ", err);
    }
  };
  async function fetchUserTrade() {
    try {
      const response = await Postrequestcall(
        FETCH_USER_TRADES,
        { SearchList: [{ userId }] },
        accessToken
      );
      const trades = response?.data?.data || [];
      const sortedTrades = trades
        .sort(
          (a, b) =>
            a.tradeType.toLowerCase().localeCompare(b.tradeType.toLowerCase()) ||
            a.tradeName.trim().toLowerCase().localeCompare(b.tradeName.trim().toLowerCase())
        )
        .map((trade) => ({
          ...trade,
          isSelected: true
        }));

      setUserTrades(sortedTrades);
    } catch (err) {
      console.error("fetchUserTrade-> Error fetching user trades: ", err);
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchEducation() {
    try {
      const response = await Postrequestcall(
        FETCH_USER_TRADE_CERTIFICATION,
        { SearchList: [{ userId }] },
        accessToken
      );
      const eduction = response?.data?.data || [];

      if (eduction) {
        const certificationsData = eduction.map((cert) => ({
          id: cert.id || 0,
          userId: cert.userId || 0,
          userName: cert.userName || "",
          school: cert.school || "",
          fieldOfStudy: cert.fieldOfStudy || "",
          years: cert.years || 0,
          tradeReceived: cert.tradeReceived || "",
          startDate: cert.startDate || moment().toISOString(),
          endDate: cert.endDate || "",
          dateCreated: cert.dateCreated || "",
          dateModified: cert.dateModified || "",
          createdBy: cert.createdBy || "",
          modifiedBy: cert.modifiedBy || "",
          createdByUserName: cert.createdByUserName || "",
          modifiedByUserName: cert.modifiedByUserName || "",
          isSelected: true
        }));

        certificationsData.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

        setCertifications(certificationsData);
      }
    } catch (error) {
      console.error("fetchEducation-> Error fetching certifications: ", error);
    } finally {
      setIsLoading(false);
    }
  }
  async function UserProducts() {
    try {
      const response = await Postrequestcall(
        FETCH_USER_PRODUCTS,
        {
          PageNr: 1,
          NrOfRecPerPage: 0,
          FullSearch: "",
          UserId: userId,
          IncludeRecordNr: true,
          TypeOfObjectReturned: "",
          SearchList: [{ UserId: userId }]
        },
        accessToken
      );
      const product = response?.data.data || [];

      if (product) {
        const productData = product.map((prod) => ({
          id: prod.productId || 0,
          userId: prod.userId || 0,
          productName: prod.productName || "",
          productType: prod.productType || "",
          manufacturerName: prod.manufacturerName || "",
          isSelected: true
        }));

        setProducts(productData);
      }
    } catch (error) {
      console.error("UserProducts-> Error fetching user products: ", error);
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchUserTickets() {
    try {
      const obj = {
        PageNr: 1,
        FullSearch: "",
        SearchList: [{ Id: 0, CreatedBy: userId }],
        IncludeRecordNr: false
      };

      const response = await Postrequestcall(FETCH_TICKETS, obj, accessToken);
      const tickets = response?.data?.data || [];
      if (!tickets || tickets.length === 0) return;

      const current = moment().format("YYYY-MM-DDThh:mm:ss");

      const userTickets = tickets.map((tick) => ({
        ...tick,
        isSelected: true
      }));

      const validTickets = userTickets.filter(
        (ticket) => !ticket.expiry || ticket.expiry >= current
      );

      const expiredTickets = userTickets.filter(
        (ticket) => ticket.expiry && ticket.expiry < current
      );

      setTickets([
        ...validTickets.sort((a, b) => new Date(b.issuedOn) - new Date(a.issuedOn)),
        ...expiredTickets.sort((a, b) => new Date(b.issuedOn) - new Date(a.issuedOn))
      ]);
    } catch (err) {
      console.error("fetchUserTickets-> Error fetching user ticket list: ", err);
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchYourInfo() {
    try {
      // const [email, phone] = await Promise.all([
      const [phone] = await Promise.all([
        // Postrequestcall(FETCH_USER_EMAILS, { SearchList: [{ userId }] }, accessToken),
        Postrequestcall(FETCH_USER_PHONES, { SearchList: [{ userId }] }, accessToken)
      ]);

      // const emailRes = email?.data?.data || [];
      const phoneRes = phone?.data?.data || [];

      // const emailData =
      //   emailRes?.map((email) => ({
      //     id: email.id || 0,
      //     userId: email.userId || userId,
      //     emailType: email.emailType || "",
      //     email: email.email || "",
      //     verified: email.verified || "",
      //     modifiedBy: email.modifiedBy || userId,
      //     isSelected: false
      //   })) || [];

      const primaryEmail = {
        email: loginData?.userInformation?.Email,
        emailType: "Primary",
        verified: true,
        id: 0,
        isSelected: true
      };

      // setEmails([primaryEmail, ...emailData]);
      setEmails([primaryEmail]);

      let hasSelectedHPhone = false;

      const phoneData =
        phoneRes?.map((phone) => {
          const isSelected = phone.phoneType === "M" && !hasSelectedHPhone;
          if (isSelected) hasSelectedHPhone = true;
          return {
            id: phone.id || 0,
            userId: phone.userId || userId,
            phoneType: phone.phoneType || "",
            phoneNo: phone.phoneNo || "",
            modifiedBy: phone.modifiedBy || userId,
            isSelected
          };
        }) || [];

      setPhones(phoneData);
    } catch (error) {
      console.error("fetchYourInfo-> Error fetching user info: ", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }

  const handleNextStep = () => {
    if (step < totalSteps) {
      setStep((prevStep) => prevStep + 1);
    }
  };
  const handlePreviousStep = () => {
    if (step > 1) {
      setStep((prevStep) => prevStep - 1);
    }
  };
  const toggleComponents = () => {
    navigate("/resume-builder");
  };
  const toggleComponentsToApplyResume = () => {
    onClose();
    setErrorMessage("");
  };

  async function handleGenerateResume() {
    try {
      setLoading(true);
      const selectedEmail = emails.find(({ isSelected }) => isSelected)?.email || "";
      const updatePhoneNo =
        phones
          .find(({ isSelected }) => isSelected)
          ?.phoneNo?.replace(/[`~!@#$%^*()_|+\-=?;:'"' ',.<>]/gi, "") || "";

      const selectedTrades = userTrades
        .filter(({ isSelected }) => isSelected)
        .map(({ tradeName }) => tradeName);

      const selectedCompanies = [
        ...workHistory
          .filter(({ isSelected }) => isSelected)
          .map(({ experience, ...rest }) => rest),
        ...unknownCompany
          .filter(({ isSelected }) => isSelected)
          .map((item) => ({
            ...item,
            nocompny: item.nocompny || "No Company Name"
          }))
      ];

      const selectedTickets = tickets
        .filter(({ isSelected }) => isSelected)
        .map(({ sharedTicketsList, ...rest }) => rest);
      const selectedEducation = certifications.filter(({ isSelected }) => isSelected);
      const selectedProduct = products.filter(({ isSelected }) => isSelected);

      const obj = {
        Companies: selectedCompanies,
        Educations: selectedEducation,
        ProductList: selectedProduct,
        Email: selectedEmail,
        Experiences: selectedCompanies,
        PhoneNo: updatePhoneNo,
        Tickets: selectedTickets,
        UserTrades: selectedTrades,
        firstName: String(loginData?.userInformation?.FirstName),
        lastName: String(loginData?.userInformation?.LastName),
        userId: Number(userId)
      };
      const response = await Postrequestcall(GENERATE_RESUME, obj, accessToken);
      const res = response?.data || [];

      if (res.message === "OK") {
        setGenResumeLink(res.data);
        setOpenResumeBuilderModal(true);
      }
    } catch (error) {
      return error;
    } finally {
      setLoading(false);
    }
  }
  const companyItemHandlePressed = (item, index) => {
    const updatedWorkHistory = workHistory.map((company, i) => {
      if (i === index) {
        const isSelected = !company.isSelected;

        return {
          ...company,
          isSelected,
          experience: company.experience.map((site) => ({
            ...site,
            isSelected
          }))
        };
      }
      return company;
    });

    setWorkHistory(updatedWorkHistory || []);
  };

  const noCompanyProjectItemHandlePressed = ({ projectIndex }) => {
    const updatedUnknownCompany = unknownCompany.map((project, index) =>
      index === projectIndex ? { ...project, isSelected: !project.isSelected } : project
    );
    setUnknownCompany(updatedUnknownCompany);
  };

  // const allNoCompanyProjectItemHandlePressed = ({ projectIndex }) => {
  //   const updatedUnknownCompany = unknownCompany.map((project, index) =>
  //     index === projectIndex ? { ...project, isSelected: !project.isSelected } : project
  //   );
  //   setUnknownCompany(updatedUnknownCompany);
  // };

  const allNoCompanyProjectItemHandlePressed = () => {
    const anySelected = unknownCompany.some((project) => project.isSelected);

    const updatedUnknownCompany = unknownCompany.map((project) => ({
      ...project,
      isSelected: !anySelected
    }));

    setUnknownCompany(updatedUnknownCompany);
  };

  const projectItemHandlePressed = ({ item, index, projectIndex }) => {
    const updatedWorkHistory = workHistory.map((company, companyIndex) => {
      if (companyIndex === index) {
        const updatedExperience = company.experience.map((project, pIndex) => {
          if (pIndex === projectIndex) {
            return { ...project, isSelected: !project.isSelected };
          }
          return project;
        });

        const isAnyProjectSelected = updatedExperience.some((proj) => proj.isSelected);

        return {
          ...company,
          isSelected: isAnyProjectSelected ? true : company.isSelected,
          experience: updatedExperience
        };
      }
      return company;
    });

    setWorkHistory(updatedWorkHistory);
  };

  const handleToggle = (index, itemType) => {
    const toggleSelection = (array, id, singleSelect = false) => {
      array?.forEach((item) => {
        if (item.id === id) {
          item.isSelected = singleSelect ? true : !item.isSelected;
        } else if (singleSelect) {
          item.isSelected = false;
        }
      });
    };

    const toggleNestedSelection = (array, id) => {
      array?.forEach((item) => {
        if (item.companyId === id) {
          const newSelectionState = !item.isSelected;
          item.experience.forEach((exp) => {
            exp.isSelected = newSelectionState;
          });
          item.isSelected = newSelectionState;
        }
      });
    };

    const updateParentSelection = (parentArray, childArray, parentKey, childKey) => {
      childArray.forEach((child) => {
        if (child.id === index) {
          child.isSelected = !child.isSelected;

          parentArray.forEach((parent) => {
            if (parent[parentKey] === child[childKey]) {
              const isAnyChildSelected = parent.experience.some((exp) => exp.isSelected);
              parent.isSelected = isAnyChildSelected;
            }
          });
        }
      });
    };

    switch (itemType) {
      case "KnownCompanies":
        toggleNestedSelection(workHistory, index);
        setWorkHistory([...workHistory]);
        break;

      case "UnknownCompanies":
        toggleNestedSelection(unknownCompany, index);
        setUnknownCompany([...unknownCompany]);
        break;

      case "ProjectCard":
        updateParentSelection(workHistory, workHistory, "companyId", "companyId");
        setWorkHistory([...workHistory]);
        break;

      case "UnKnownCompanyProjectCard":
        updateParentSelection(unknownCompany, workHistorySites, "companyId", "companyId");
        setWorkHistorySites([...workHistorySites]);
        setUnknownCompany([...unknownCompany]);
        break;

      case "EducationCard":
        toggleSelection(certifications, index);
        setCertifications([...certifications]);
        break;

      case "ProductsCard":
        toggleSelection(products, index);
        setProducts([...products]);
        break;

      case "TradesCard":
        toggleSelection(userTrades, index);
        setUserTrades([...userTrades]);
        break;

      case "TicketCard":
        toggleSelection(tickets, index);
        setTickets([...tickets]);
        break;

      case "EmailCard":
        toggleSelection(emails, index, true);
        setEmails([...emails]);
        break;

      case "PhoneCard":
        toggleSelection(phones, index, true);
        setPhones([...phones]);
        break;

      default:
        console.warn(`handleToggle-> Unhandled itemType: ${itemType}`);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      await Promise.all([
        getExperienceDetails(),
        fetchUserTrade(),
        fetchEducation(),
        UserProducts(),
        fetchUserTickets(),
        fetchYourInfo()
      ]);
      setLoading(false);
    } catch (error) {
      console.error("fetchData-> Error fetching All Data: ", error);
      setLoading(false);
    }
  };

  const handleCloseResumeDetail = () => {
    setOpenResumeBuilderModal(false);
    setGenResumeLink("");
  };

  return (
    <>
      <Box
        className="main-content-Box"
        sx={{
          p: fromJob === "apply-job" ? 0 : isSmallScreen ? 2 : 3,
          pt: fromJob === "apply-job" ? 0 : 2,
          height: fromJob === "apply-job" ? "570px" : "calc(100vh - 50px)"
        }}>
        {fromJob === "apply-job" ? <></> : <Pageheader headerName={headerName} />}
        <Card className="main-content-card">
          <Card className="pagelist-content" sx={{ p: 2, mb: 1.5 }}>
            <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
              <Box>
                {!(fromJob === "apply-job" && step === 1) && (
                  <Fab
                    color="primary"
                    size="small"
                    sx={{ boxShadow: "none" }}
                    onClick={step === 1 ? toggleComponents : handlePreviousStep}>
                    <KeyboardBackspaceIcon />
                  </Fab>
                )}
              </Box>
              <Stack spacing={1} sx={{ width: "100%" }}>
                <Stack sx={{ justifyContent: "space-between" }} direction={"row"}>
                  <Typography variant="body1">{TEXT_RESUME_INFO_SUBTITLE}</Typography>

                  <Typography variant="h6" sx={{ color: "primary" }} textAlign={"center"}>
                    {step}/{totalSteps}
                  </Typography>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={(step / totalSteps) * 100}
                  sx={{
                    height: 5,
                    borderRadius: 5,
                    backgroundColor: "#e0e0e0",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: BIBlue
                    }
                  }}
                />
              </Stack>
            </Stack>
          </Card>
          {loading ? (
            <Loader />
          ) : (
            <Box className="main-content-card-list">
              {step === 1 && (
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1.5 }}>
                  <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                    <YourInfoCard
                      handleToggle={handleToggle}
                      emails={emails}
                      phones={phones}
                      loginData={loginData}
                      fromJob={fromJob}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                    <TradesCard handleToggle={handleToggle} userTrades={userTrades} />
                  </Grid>
                </Grid>
              )}

              {step === 2 && (
                <Grid container rowSpacing={1}>
                  <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                    <ExperienceCard
                      companyItemHandlePressed={companyItemHandlePressed}
                      projectItemHandlePressed={projectItemHandlePressed}
                      noCompanyProjectItemHandlePressed={noCompanyProjectItemHandlePressed}
                      allNoCompanyProjectItemHandlePressed={allNoCompanyProjectItemHandlePressed}
                      workHistory={workHistory}
                      unknownCompany={unknownCompany}
                      itemType="ExperienceCard"
                    />
                  </Grid>
                </Grid>
              )}

              {step === 3 && (
                <Grid container spacing={1.5} sx={{ flexDirection: "column" }}>
                  <Grid item size={{ xs:12, sm:6, md:12 }}>
                    <EducationCard handleToggle={handleToggle} certifications={certifications} />
                  </Grid>

                  <Grid item size={{ xs:12, sm:6, md:12 }}>
                    <TicketCard handleToggle={handleToggle} tickets={tickets} />
                  </Grid>

                  <Grid item size={{ xs:12, sm:6, md:12 }}>
                    <ProductsCard handleToggle={handleToggle} products={products} />
                  </Grid>
                </Grid>
              )}
              {fromJob === "apply-job" ? (
                <></>
              ) : (
                <Box sx={{ mt: 2, textAlign: "right" }}>
                  <Button
                    loading={loading}
                    variant="contained"
                    onClick={step < totalSteps ? handleNextStep : handleGenerateResume}>
                    {step < totalSteps ? TEXT_NEXT_PAGE_BTN : TEXT_GENERATE_RESUME_BTN}
                  </Button>
                </Box>
              )}
            </Box>
          )}

          {fromJob === "apply-job" ? (
            <>
              <Divider />
              <Stack
                sx={{
                  gap: 1,
                  mt: 1,
                  justifyContent: "flex-end",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row"
                }}>
                <Box>
                  {!(fromJob === "apply-job" && step === 1) && (
                    <Button
                      loading={loading}
                      sx={{ color: "gray", border: "1px solid gray" }}
                      onClick={step === 1 ? toggleComponentsToApplyResume : handlePreviousStep}>
                      {BUTTON_BACK}
                    </Button>
                  )}
                </Box>
                <Box>
                  <Button
                    loading={loading}
                    variant="contained"
                    onClick={step < totalSteps ? handleNextStep : handleGenerateResume}>
                    {step < totalSteps ? TEXT_NEXT_PAGE_BTN : TEXT_GENERATE_RESUME_BTN}
                  </Button>
                </Box>
              </Stack>
            </>
          ) : (
            <></>
          )}
        </Card>
      </Box>
      {openResumeBuilderModal && (
        <ResumeDetailsModal
          Open={openResumeBuilderModal}
          Close={handleCloseResumeDetail}
          resumeData={genResumeLink}
          from={"Add-Resume"}
          fromJob={fromJob}
          handleClose={handleClose}
          loadApi={loadApi}
          fetchResumes={fetchResumes}
          setOpenResumeBuilder={setOpenResumeBuilder}
          setErrorMessage={setErrorMessage}
        />
      )}
    </>
  );
};

export default AddResume;
